<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  mounted () {
    // set 'app-background' class to body
    const bodyElement = document.body
    bodyElement.classList.add('app-background')
    const htmlElement = document.documentElement
    htmlElement.setAttribute('theme', 'light')
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}
</style>
